import paths from "~/constants/paths";
import useCart from "~/composables/Checkout/useCart";

export default defineNuxtRouteMiddleware(() => {
  const { isCartEmpty } = useCart();

  if (isCartEmpty.value) {
    return navigateTo(paths.cart);
  }
});
